import { useState, useEffect } from 'react';
import classNames from 'classnames';
import ChoiceDistributor from './ChoiceDistributor';
import Titles from './Titles';
import WidgetActions from './WidgetActions';
import Configurator from './Configurator';
import SubmitForm from './SubmitForm';


//load files from react local
if(window.CRBVars === undefined) {
	window.CRBVars = {
		"reactAppUri": ''
	};
};

function ConfiguratorPage() {
	const [configData, setConfigData] = useState(null);
	const [currentStep, setCurrentStep] = useState(0); // Start at step 0 for model selection
	const [selection, setSelection] = useState({
		model: null,
		size: null,
		structureColor: null,
		canopyColor: null,
		base: "/models/56413.glb",
		valance: null,
		hasFringe: false,
	});
	const [hideMobileMenu, setHideMobileMenu] = useState(false);

	useEffect(() => {
		const data = {
			models: [
				{
					name: "King",
					image: "/images/choices/product-1.png",
					sizes: [
						{
							name: "40x40 NEW 7/22",
							image: "/images/choices/top-2.png",
							glb: "/models/56696.glb",
							structure: {
								groupTitle: "Choose Structure Color",
								colors: [
									{ name: "Structure Wood", preview: "/images/structure/structure_faux_wood.png", texture: "materials/structure/wood.jpeg" },
									{ name: "Structure Black", preview: "/images/structure/structure_black.png", texture: "0x000000" },
									{ name: "Structure Chrome", preview: "/images/structure/structure_chrome.png", texture: "0xa8a9ad" },
									{ name: "Structure Cream", preview: "/images/structure/structure_cream.png", texture: "0xFFFDD0" },
									{ name: "Structure Graphite", preview: "/images/structure/structure_graphite.png", texture: "0x565656" },
									{ name: "Structure White", preview: "/images/structure/structure_white.png", texture: "0xFFFFFF" },
								]
							},
							canopy: {
								groupTitle: "Choose Canopy Color",
								colors: [
									{ name: "Terracotta", preview: "/images/top/terracotta.png", texture: "6222" },
									{ name: "Royal Blue Tweed", preview: "/images/top/royal-blue.png", texture: "6223" },
									{ name: "Sunflower", preview: "/images/top/sunflower.png", texture: "6221" },
									{ name: "Wheat", preview: "/images/top/wheat.png", texture: "6224" },
									{ name: "White", preview: "/images/top/white.png", texture: "6225" },
								]
							},
							valances: {
								groupTitle: "Choose a Valance",
								options: [
									{ name: "Valence 1", id: "Valance1", fringeId: "Fringe1", pipeId: "Binding1", preview: "/images/valance/valance_a_red.png" },
									{ name: "Valence 2", id: "Valence2", fringeId: "Fringe2", pipeId: "Binding2", preview: "/images/valance/valance_d_red.png" },
									{ name: "Valence 3", id: "Valence3", fringeId: "Fringe3", pipeId: "Binding3", preview: "/images/valance/valance_g_red.png" },
									{ name: "Valence 4", id: "Valence4", fringeId: "Fringe4", pipeId: "Binding4", preview: "/images/valance/valance_i_red.png" },
									{ name: "Valence 5", id: "Valence5", fringeId: "Fringe5", pipeId: "Binding5", preview: "/images/valance/valance_l_red.png" },
									{ name: "Valence 6", id: "Valence6", fringeId: "Fringe6", pipeId: "Binding6", preview: "/images/valance/valance_e_red.png" },
									{ name: "Valence 7", id: "Valence7", fringeId: "Fringe7", pipeId: "Binding7", preview: "/images/valance/valance_h_red.png" },
									{ name: "Valence 8", id: "Valence8", fringeId: "Fringe8", pipeId: "Binding8", preview: "/images/valance/valance_c_red.png" },
								]
							},
							fringes: {
								groupTitle: "Add a Fringe?",
								options: [
									{ name: "Yes", value: true },
									{ name: "No", value: false },
								]
							},
							bases:{
								groupTitle: "Choose a Base",
								options: [
									{ name: "Base 1", glb: "/models/56413.glb", preview: "/images/bases/base04.png" },
									// { name: "Base 2", glb: "/models/56382.glb", preview: "/images/bases/base02.png" },
									{ name: "Base 3", glb: "/models/56381.glb", preview: "/images/bases/base03.png" },
									{ name: "Base 4", glb: "/models/56380.glb", preview: "/images/bases/base01.png" },
								]
							}
						},
						{
							name: "40x40 OLD 7/10",
							image: "/images/choices/top-2.png",
							glb: "/models/KING4040.glb",
							structure: {
								groupTitle: "Choose Structure Color",
								colors: [
									{ name: "Structure Wood", preview: "/images/structure/structure_faux_wood.png", texture: "materials/structure/wood.jpeg" },
									{ name: "Structure Black", preview: "/images/structure/structure_black.png", texture: "0x000000" },
									{ name: "Structure Chrome", preview: "/images/structure/structure_chrome.png", texture: "0xa8a9ad" },
									{ name: "Structure Cream", preview: "/images/structure/structure_cream.png", texture: "0xFFFDD0" },
									{ name: "Structure Graphite", preview: "/images/structure/structure_graphite.png", texture: "0x565656" },
									{ name: "Structure White", preview: "/images/structure/structure_white.png", texture: "0xFFFFFF" },
								]
							},
							canopy: {
								groupTitle: "Choose Canopy Color",
								colors: [
									{ name: "Terracotta", preview: "/images/top/terracotta.png", texture: "6222" },
									{ name: "Royal Blue Tweed", preview: "/images/top/royal-blue.png", texture: "6223" },
									{ name: "Sunflower", preview: "/images/top/sunflower.png", texture: "6221" },
									{ name: "Wheat", preview: "/images/top/wheat.png", texture: "6224" },
									{ name: "White", preview: "/images/top/white.png", texture: "6225" },
								]
							},
							valances: {
								groupTitle: "Choose a Valance",
								options: [
									{ name: "Valence 1", id: "Valance1", fringeId: "Fringe1", pipeId: "Pipe1", preview: "/images/valance/valance_a_red.png" },
									{ name: "Valence 2", id: "Valence2", fringeId: "Fringe2", pipeId: "Pipe2", preview: "/images/valance/valance_d_red.png" },
									{ name: "Valence 3", id: "Valence3", fringeId: "Fringe3", pipeId: "Pipe3", preview: "/images/valance/valance_g_red.png" },
									{ name: "Valence 4", id: "Valence4", fringeId: "Fringe4", pipeId: "Pipe4", preview: "/images/valance/valance_i_red.png" },
									{ name: "Valence 5", id: "Valence5", fringeId: "Fringe5", pipeId: "Pipe5", preview: "/images/valance/valance_l_red.png" },
									{ name: "Valence 6", id: "Valence6", fringeId: "Fringe6", pipeId: "Pipe6", preview: "/images/valance/valance_e_red.png" },
									{ name: "Valence 7", id: "Valence7", fringeId: "Fringe7", pipeId: "Pipe7", preview: "/images/valance/valance_h_red.png" },
									{ name: "Valence 8", id: "Valence8", fringeId: "Fringe8", pipeId: "Pipe8", preview: "/images/valance/valance_c_red.png" },
								]
							},
							fringes: {
								groupTitle: "Add a Fringe?",
								options: [
									{ name: "Yes", value: true },
									{ name: "No", value: false },
								]
							},
							bases:{
								groupTitle: "Choose a Base",
								options: [
									{ name: "Base 1", glb: "/models/56413.glb", preview: "/images/bases/base04.png" },
									// { name: "Base 2", glb: "/models/56382.glb", preview: "/images/bases/base02.png" },
									{ name: "Base 3", glb: "/models/56381.glb", preview: "/images/bases/base03.png" },
									{ name: "Base 4", glb: "/models/56380.glb", preview: "/images/bases/base01.png" },
								]
							}
						}

					]
				}
			]
		};
		setConfigData(data);
	}, []);

	if (!configData) {
		return <div>Loading...</div>; // Or a spinner component
	}

	const handleSelection = (step, value) => {
		const newSelection = { ...selection };
		const nextStep = currentStep + 1;

		switch (step) {
			case 0: // Model
				newSelection.model = value;
				console.log("Changed model");
				break;
			case 1: // Size
				newSelection.size = value;
				break;
			case 2: // Structure Color
				newSelection.structureColor = value;
				break;
			case 3: // Canopy Color
				newSelection.canopyColor = value;
				break;
			case 4: // Valance
				newSelection.valance = value;
				// If user selects "No Valance", skip fringe selection
				if (!value) {
					setCurrentStep(nextStep + 1);
				}
				break;
			case 5: // Has Fringe
				newSelection.hasFringe = value;
				break;
			case 6: // Base
				newSelection.base = value;
				break;
			default:
				break;
		}

		setSelection(newSelection);
		// setCurrentStep(nextStep);
	};

	const totalSteps = 7; // Model, Size, Structure, Canopy, Valance, Fringe, Base

	return (
		<section className={classNames('section-configurator-alt js-configurator', { 'is-menu-hidden': hideMobileMenu })}>
			<div className="section__inner">
				<div className="section__main">
					<div className="section__head"></div>
					<div className="section__media">
						<Configurator selection={selection} configData={configData} />
					</div>
				</div>
				<div className="section__aside">
					<div className="section__aside-head" style={{ width: '10px', margin: '0 auto' }}>
						<button className="section__aside-btn" onClick={() => setHideMobileMenu(!hideMobileMenu)}>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z" /></svg>
                        </button>
					</div>
					<div className="widget-configurator">
						<div className="widget__head">
							<Titles currentStep={currentStep} selection={selection} configData={configData} />
						</div>
						<div className="widget__body">
							{currentStep < totalSteps ? (
								<ChoiceDistributor
									currentStep={currentStep}
									configData={configData}
									selection={selection}
									onSelect={handleSelection}
								/>
							) : (
								<SubmitForm selection={selection} />
							)}
						</div>
						<WidgetActions
							currentStep={currentStep}
							setCurrentStep={setCurrentStep}
							totalSteps={totalSteps}
						/>
					</div>
				</div>
			</div>
		</section>
	);
}

export default ConfiguratorPage;